<template>
  <!-- 首页 -->
  <el-container >
    <el-main class="full-screen">
      <div class="detail-box">
        <el-row class="center-row">
          <h1 class="ft3 mt-4">{{ $t("indexmessage.title1") }}</h1>
        </el-row>
        <el-row class="center-row mt-3">
          <h2 class="ft1">{{ $t("indexmessage.title2") }}</h2>
        </el-row>
        <el-row class="center-row mt-3"
          ><el-button
            type="primary"
            size="mini"
            round
            class="borderless-button"
            :icon="Search"
            @click="navigateToData"
            style="line-height: 40px; height: 40px; padding: 5;"
          >
            <h4>{{ $t("indexmessage.title3") }}</h4>
            </el-button
          >
        </el-row>
        <el-row class="center-row mt-3" justify="center">
          
          <el-carousel
            class="mt-4 contain-image"
            :interval="4000"
            type="card"
            height="400px"
            style="width:1080px;"
          >
          
            <el-carousel-item  v-for="(image, index) in images" :key="index">
              <div class="carousel-item-content">
              <img
                :src="image.url"
                :alt="image.alt"
                class="full-image"
                @click="showLargeImage(image.url,image.alt)"
              />
              <!-- <div class="overlay-text">{{image.alt}}</div> -->
            </div>
            </el-carousel-item>
          </el-carousel>
        
        </el-row>

        <el-dialog v-model="centerDialogVisible" width="60%" center>
          <div class="carousel-item-content">
          <img
            :src="currentLargeImage"
            alt="Large Image"
            style="width: 100%; height: auto;"
          />
          <!-- <div class="overlay-text">{{currentImgtitle}}</div> -->
          </div>
        </el-dialog>
      </div>
    </el-main>

    <el-footer class="myfoot ">
      <el-row style="margin-top:50px;">
        <el-col :span="5">
          <img src="../assets/cpeos.png" style="height:85%"
        /></el-col>

        <el-col :span="14">
          <!-- <el-row>
            <div class="footerfont">LAOS NODE SERVICE </div>
          </el-row> -->
          <el-row>
            <div class="ft2 mt-3">
              Copyright © 2011-2022 CHEOS All rights reserved. 京ICP备20003293号-5 京公网安备11010502042296号&nbsp;&nbsp;&nbsp;
            </div>
          </el-row>
        </el-col>
        <el-col :span="5"> </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const router = useRouter();
    const { t } = useI18n(); //使用i18n对象
    // 对于导入的图像路径，可以使用 require 来获取正确的路径
    const images = ref([
      { url: require("../assets/coverimg1.png"), alt: "GF-1 Mekong River" },
      { url: require("../assets/coverimg2.png"), alt: "GF-2 Mekong River" },
      { url: require("../assets/coverimg3.png"), alt: "GF-7 Railway Station, Vientiane, Laos" },
    ]);

    const centerDialogVisible = ref(false);

    const currentLargeImage = ref("");
    const currentImgtitle=ref("")

    const showLargeImage = (url,title) => {
      currentLargeImage.value = url;
      centerDialogVisible.value = true;
      currentImgtitle.value=title;
    };
    const navigateToData = () => {
      // 在这里替换 'your-route-path' 为你想要导航的路由路径
      router.push("/querymap");
    };
    return {
      images,
      currentLargeImage,
      showLargeImage,
      currentImgtitle,
      centerDialogVisible,
      navigateToData,
      t
    };
  },
};
</script>

<style scoped>
body {
  overflow-x: hidden;
}

.myfoot {
  height: 200px !important;
  background-image: url("../assets/footerbackground.png");
  align-items: center;
}
.full-screen {
  background-image: url("../assets/two-bg.png") !important;
  overflow-x: hidden;
}
.full-image {
  object-fit: contain;
  width: 100%;
  height: auto;
}
.contain-image{
  margin: 0;
      padding: 0;
      align-items: flex-end;
}

.ft1 {
  font-size: 1.875rem;
  font-family: GenSekiGothic TW TTF;
  font-weight: 800;
  color: #683535;
}
.ft2 {
  font-size: 0.875rem;
  font-family: GenSekiGothic TW TTF;
  font-weight: 400;
  color: white;
}

.footerfont {
  font-size: 1.875rem;
  font-family: GenSekiGothic TW TTF;
  font-weight: 800;
  color: white;
}
.ft3 {
  font-size: 3.25rem;
  font-family: Arial;
  font-weight: 700;
  color: #050505;
  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(#005fe9),
    to(#3e8dff)
  );
  background: linear-gradient(0deg, #005fe9, #3e8dff);
  background-clip: border-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  margin-bottom: 50px;
}

.ft3::after {
  content: "";
  display: block;
  position: absolute;
  bottom: -30px; /* 距离底部的距离，可以根据需要调整 */
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 14px; /* 下划线的高度，可以根据需要调整 */
  background-color: #f90; /* 设置下划线颜色 */
  border-radius: 7px;
}

.center-row {
  align-items: center;
  display: flex;
  justify-content: center; /* 水平居中 */
}

.t2 {
  font-size: 25px !important; /* 设置字体大小为18像素 */
}

.mess {
  font-size: 1.2rem;
  font-family: GenSekiGothic TW TTF;
  font-weight: 200;
}

.detail-box {
  width: 85vw;
  margin: 0 auto;
  padding: 10px; /* 可选，为内容添加内边距 */
}
.divider {
  color: #333;
  background-color: #333;
  height: 2px;
}


.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

el-container{
  overflow-x: hidden;
}

body {
  overflow-x: hidden !important;
}



.carousel-item-content {
  position: relative;
  display: inline-block;
}

.overlay-text {
  position: absolute;
  bottom: 1px;
  right: 1px;
  background-color: rgba(255, 255, 255, 0.7); /* 半透明背景色 */
  color: black;
  padding: 5px;
  opacity: 1; /* 默认显示 */
  transition: opacity 0.3s ease; /* 添加淡入淡出效果 */
}
</style>
